import InputTag from './input-tag';

export default InputTag;
